import { useTranslation } from "react-i18next";
import { useToast } from "@/hooks/use-toast";
import { ToastAction } from "@/components/ui/toast";

export type RemoveWithUndoOptions = {
  /** Chave i18n já resolvida ou crua, usada como título do toast. */
  message: string;
  remove: () => Promise<unknown>;
  restore: () => Promise<unknown>;
};

export function usePetProfileUndo() {
  const { t } = useTranslation("daycareHotel");
  const { toast } = useToast();

  const removeWithUndo = async ({ message, remove, restore }: RemoveWithUndoOptions) => {
    try {
      await remove();
    } catch {
      toast({ title: t("petProfile.saveError"), variant: "destructive" });
      return;
    }

    toast({
      title: message,
      action: (
        <ToastAction
          altText={t("petProfile.undo")}
          onClick={() => {
            void restore().catch(() => {
              toast({ title: t("petProfile.saveError"), variant: "destructive" });
            });
          }}
        >
          {t("petProfile.undo")}
        </ToastAction>
      ),
    });
  };

  return { removeWithUndo };
}
